export const PROFESSION_TALKS_LINK =
  "https://www.youtube.com/watch?v=FkarFeYbS-w&list=PL4Yjq9yLt-Ghgfqz0BC7yqq6gYz0rWH-c";
